import { render, staticRenderFns } from "./SubmitFormItem.vue?vue&type=template&id=30e007ea&scoped=true"
import script from "./SubmitFormItem.vue?vue&type=script&lang=js"
export * from "./SubmitFormItem.vue?vue&type=script&lang=js"
import style0 from "./SubmitFormItem.vue?vue&type=style&index=0&id=30e007ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e007ea",
  null
  
)

export default component.exports